/**
 * Goods Sales Store
 *
 * @author minkyoung.park@emcast.com
*/
// states
const state = {
    ordererName: '',
    ordererEmail: '',
    ordererPhone: ''
}

// getters
const getters = {}

// mutations
const mutations = {
    SET_ORDERERENAME(state, value) {
        state.ordererName = value
    },
    SET_ORDEREREMAIL(state, value) {
        state.ordererEmail = value
    },
    SET_ORDEREREPHONE(state, value) {
        state.ordererPhone = value
    },
}

// actions
const actions = {
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}